import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useKeycloak } from '@react-keycloak/web';
import { CBadge } from '@coreui/react';
import { useUserRoles } from 'src/helpers/keycloakUtils';


export const AppSidebarNav = ({ items, isCollapsed }) => {
  const location = useLocation()
  const { keycloak } = useKeycloak();
  const userRoles = useUserRoles();
  
  const navLink = (name, icon, badge) => {
    return (
      <div className="sidebar-item">
        {icon && <span className="nav-icon">{icon}</span>}
        {!isCollapsed && name && <span className="nav-text">{name}</span>}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </div>
    );
  };

  const navItem = (item, index) => {
    const { component, name, badge, icon,roles, ...rest } = item;
    const Component = component;
    if(roles && !roles.some(role => userRoles.includes(role))) return null;
    return ( 
      <Component
        {...(rest.to &&
          !rest.items && {
            component: NavLink,
          })}
        key={index}
        {...rest}
      >
        { navLink(name, icon, badge)}
      </Component>
    ) ;
  };

  const navGroup = (item, index) => {
    const { component, name, icon, to, ...rest } = item;
    const Component = component;
    return (
      <Component
        idx={String(index)}
        key={index}
        toggler={navLink(name, icon)}
        visible={location.pathname.startsWith(to)}
        {...rest}
      >
        {item.items?.map((subItem, subIndex) =>
          subItem.items ? navGroup(subItem, subIndex) : navItem(subItem, subIndex),
        )}
      </Component>
    );
  };

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  );
};

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isCollapsed: PropTypes.bool.isRequired,
};
